import { render } from "./ItemDetails.vue?vue&type=template&id=3dcd961c&scoped=true"
import script from "./ItemDetails.vue?vue&type=script&lang=js"
export * from "./ItemDetails.vue?vue&type=script&lang=js"

import "./ItemDetails.vue?vue&type=style&index=0&id=3dcd961c&scoped=true&lang=css"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcd961c"]])

export default __exports__